import { load } from "@cashfreepayments/cashfree-js";

export const openCashfreeCheckout = async (subscription_session_id) => {
  try {
    const cashfree = await load({
      mode: "sandbox",
    });

    cashfree.subscriptionsCheckout({
      subsSessionId: subscription_session_id,
      redirectTarget: "_self",
    });
  } catch (error) {
    console.error("Cashfree Checkout Error:", error);
  }
};